import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useFavouriteGame from '../useFavouriteGame';

const useFavouriteToggle = () => {
  const { game } = useGameContext();
  const { isFavourite, handleClick } = useFavouriteGame(game);

  const buttonLabel = isFavourite
    ? 'game.added_favourites'
    : 'game.add_favourites';
  return { isFavourite, buttonLabel, handleClick };
};

export default useFavouriteToggle;
